<template>
  <div class="profit-ranking">
    <div class="page-header"><div class="page-icon">💰</div><h2>利润排行</h2></div>

    <!-- 搜索 + 日期 -->
    <el-form inline>
      <el-form-item label="商品名称">
        <el-input
          v-model="searchName"
          placeholder="输入商品名称"
          clearable
          @input="debouncedLoad"
        />
      </el-form-item>

      <el-form-item label="起始日期">
        <el-date-picker
          v-model="start"
          type="date"
          placeholder="选择日期"
        />
      </el-form-item>
      <el-form-item label="结束日期">
        <el-date-picker
          v-model="end"
          type="date"
          placeholder="选择日期"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="load">查询</el-button>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table
      :data="list"
      stripe
      style="width:100%"
      v-loading="loading"
    >
      <el-table-column prop="product_name" label="商品名称" />
      <el-table-column prop="profit" label="利润 (元)">
        <template #default="{row}">
          <span :class="Number(row.profit) >= 0 ? 'profit-positive' : 'profit-negative'">
            {{ Number(row.profit).toFixed(1) }}
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 最简洁的合计行（纯文字） -->
    <div v-if="list.length > 0" style="margin-top: 10px; text-align: right;">
      合计：{{ totalProfit.toFixed(1) }} 元
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import axios from 'axios'
import API_BASE from '@/api';
import dayjs from 'dayjs'
import { debounce } from 'lodash-es'

const start = ref(null)
const end = ref(null)
const searchName = ref('')
const list = ref([])
const loading = ref(false)

// 防抖查询
const debouncedLoad = debounce(() => {
  load()
}, 500)

// 立即查询
const load = async () => {
  loading.value = true
  const params = {}

  if (start.value && end.value) {
    const s = dayjs(start.value).startOf('day').format('YYYY-MM-DD HH:mm:ss')
    const e = dayjs(end.value).endOf('day').format('YYYY-MM-DD HH:mm:ss')
    params.start = s
    params.end = e
  }

  if (searchName.value.trim()) {
    params.name = searchName.value.trim()
  }

  try {
    const { data } = await axios.get(`${API_BASE}/api/profit-ranking`, { params })
    if (data.success) {
      list.value = data.data.map(row => ({
        ...row,
        profit: Number(row.profit)
      }))
    }
  } catch (err) {
    console.error(err)
  } finally {
    loading.value = false
  }
}

// 计算总利润（纯数字）
const totalProfit = computed(() => {
  return list.value.reduce((sum, item) => sum + Number(item.profit || 0), 0)
})

// 监听日期变化，自动查询
watch([start, end], () => {
  if (start.value && end.value) {
    load()
  }
})

onMounted(() => load())
</script>

<style scoped>
.profit-ranking {
  padding: 0;
}
.profit-positive { color: var(--success); font-weight: 600; }
.profit-negative { color: var(--danger); font-weight: 600; }
.el-form { padding: 0; margin-bottom: 16px; }
</style>
